var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list-tile',{attrs:{"to":{
      name: 'showNotification',
      params: {
        notificationType: 'announcement',
        notificationId: _vm.announcement.id
      }
    }}},[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("\n        "+_vm._s(_vm.announcement.displayStartDate)+"\n        "),(_vm.announcement.isNew)?_c('v-chip',{staticClass:"text-xs-center",attrs:{"label":"","color":"red","text-color":"white"}},[_vm._v("NEW\n        ")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("\n        "+_vm._s(_vm.announcement.title)+"\n      ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('i',{staticClass:"material-icons"},[_vm._v("chevron_right")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }